@if (loanService.application()?.oldProperty && (loanService.application()?.oldProperty?.type !== -1
  || loanService.application()?.oldProperty?.futurePropertyOwnership === 'confirmedContract')) {
  <h3 class="title">Existerande bostad</h3>

  @if (loanService.application()?.oldProperty?.futurePropertyOwnership) {
    <p>
      Kund har svarat:
      {{ OldPropertyStatusMap.get(loanService.application()?.oldProperty?.futurePropertyOwnership!) + '.' || 'FEL: Inget svar från kund' }}

      @if (propertiesWithoutKalp
        .includes(loanService.application()?.oldProperty?.futurePropertyOwnership!)) {
        <p>
          Kostnader kopplade till befintlig bostad medräknas inte i
          KALP-resultat.
        </p>
      }
    </p>
  }

  <div class="group-holder">
    <div class="subgroup-holder">
      @if ((loanService.application()?.oldProperty?.type ?? -1) >= 0) {
        <spb-kalp-item
          [textValue]="true"
          text="Typ av bostad"
          [value]="(loanService.application()?.oldProperty?.type ?? 0) | propertyType"/>
      }
      <spb-kalp-item
        format="1.0-0"
        text="Totala lånebeloppet på lån mot bostaden"
        [value]="loanService.application()?.oldProperty?.loanAmount"/>
      @if (loanService.application()?.oldProperty?.price) {
        <spb-kalp-item
          format="1.0-0"
          [text]="loanService.application()?.oldProperty?.futurePropertyOwnership === 'confirmedContract' ?
        'Försäljningspris' : 'Uppskattat försäljningspris'"
          [value]="loanService.application()?.oldProperty?.price"/>
      }
      <spb-kalp-item
        format="1.0-0"
        text="Driftskostnad (kr/mån)"
        [value]="loanService.application()?.oldProperty?.runCost"/>
      <spb-kalp-item
        format="1.0-0"
        text="Fastighetsavgift (kr/mån)"
        [value]="loanService.application()?.oldProperty?.tax"/>
      @if (loanService.application()?.oldProperty?.type === 2) {
        <spb-kalp-item
          description="endast om bostadsrätt"
          format="1.0-0"
          text="Avgift (kr/mån)"
          [value]="loanService.application()?.oldProperty?.fee"/>
      }
      @if (loanService.application()?.oldProperty?.type === 3) {
        <spb-kalp-item
          description="endast om hyressrätt"
          format="1.0-0"
          text="Hyra (kr/mån)"
          [value]="loanService.application()?.oldProperty?.fee"/>
      }
    </div>
  </div>
}